import { CommonModule } from '@angular/common';
import { Component, Input, OnChanges, OnDestroy, SimpleChanges } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { Browser } from '@capacitor/browser';
import { IonicModule } from '@ionic/angular';
import { TranslateModule } from '@ngx-translate/core';
import { ImagePipe } from 'src/app/pipes/image/image';

@Component({
  selector: 'audio-player',
  templateUrl: 'audio-player.html',
  styleUrls: ['audio-player.scss'],
  standalone: true,
  imports: [CommonModule, IonicModule, FormsModule, TranslateModule, ImagePipe],
})
export class AudioPlayerComponent implements OnChanges, OnDestroy {
  public mediaSecAtual = 0;
  public duracaoAudio = 0;
  public playing = false;
  private audio = new Audio();
  private seeking = false;
  @Input() audioUrl: string | undefined;
  @Input() nome: string | '';
  @Input() smallVersion: boolean = true;
  @Input() image: string | '';

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['audioUrl'] && changes['audioUrl'].currentValue) {
      this.loadAudio(changes['audioUrl'].currentValue);
      this.playing = false;
    }
  }

  loadAudio(url: string) {
    this.audio.src = url;
    this.audio.load();
    this.audio.onloadedmetadata = () => {
      this.duracaoAudio = Math.floor(this.audio.duration);
    };
    this.audio.ontimeupdate = () => {
      if (!this.seeking) this.mediaSecAtual = Math.floor(this.audio.currentTime);
    };
    this.audio.onended = () => this.stop();
  }

  togglePlay() {
    this.playing ? this.pause() : this.play();
  }

  play() {
    this.audio.play();
    this.playing = true;
  }

  pause() {
    this.audio.pause();
    this.playing = false;
  }

  stop() {
    this.audio.pause();
    this.audio.currentTime = 0;
    this.playing = false;
  }

  back() {
    this.audio.currentTime = Math.max(this.audio.currentTime - 10, 0);
  }

  next() {
    this.audio.currentTime = Math.min(this.audio.currentTime + 10, this.audio.duration);
  }

  /** Clique direto na barra de progresso */
  onSeek(event: MouseEvent) {
    const bar = (event.currentTarget as HTMLElement).querySelector('.bar');
    if (!bar) return;
    const rect = bar.getBoundingClientRect();
    const percent = Math.min(Math.max((event.clientX - rect.left) / rect.width, 0), 1);
    this.audio.currentTime = percent * this.duracaoAudio;
    this.mediaSecAtual = this.audio.currentTime;
  }

  /** Controle de arraste */
  startSeek(event: MouseEvent) {
    this.seeking = true;
    this.seekMove(event);
  }

  seekMove(event: MouseEvent) {
    if (!this.seeking) return;
    const bar = document.querySelector('.bar');
    if (!bar) return;
    const rect = bar.getBoundingClientRect();
    const percent = Math.min(Math.max((event.clientX - rect.left) / rect.width, 0), 1);
    this.mediaSecAtual = percent * this.duracaoAudio;
  }

  endSeek(event: MouseEvent) {
    if (!this.seeking) return;
    this.seeking = false;
    const bar = document.querySelector('.bar');
    if (!bar) return;
    const rect = bar.getBoundingClientRect();
    const percent = Math.min(Math.max((event.clientX - rect.left) / rect.width, 0), 1);
    this.audio.currentTime = percent * this.duracaoAudio;
    this.mediaSecAtual = this.audio.currentTime;
  }

  formatarSegundos(segundos: number): string {
    const h = Math.floor(segundos / 3600);
    const m = Math.floor((segundos % 3600) / 60);
    const s = Math.floor(segundos % 60);
    const pad = (v: number) => v.toString().padStart(2, '0');
    return h > 0 ? `${pad(h)}:${pad(m)}:${pad(s)}` : `${pad(m)}:${pad(s)}`;
  }

  async baixar() {
    if (this.audioUrl) {
      await Browser.open({ url: this.audioUrl });
    }
  }

  ngOnDestroy() {
    this.audio.pause();
    this.audio.src = '';
  }
}
